import { RwSelector } from "./constants/rw-object.constants";
import { Capping } from "./marketing-client-capping";
import { MarketingClientRWBase } from "./marketing-client-rw-base";
import { Utilization } from "./marketing-client-utilization";
import { BigDataClickID } from "./constants/big-data-constants";
import { EventType } from "./constants/event-type-constants";
import { UtilizationConstants } from "./constants/marketing-client-utilization-constants";
import { DeviceInformationHelper } from "./helpers/device-information-helper";
import { DOMHelper } from "./helpers/dom-helper";
import { HttpHeaders } from "./http/sub-types/http-headers";
import { httpInstance } from "./http/http";

export class MarketingClientRWOwner extends MarketingClientRWBase {
    purchaseSubscription = ".button-purchase";
    purchaseButton: HTMLElement | null;
    rwElement: HTMLElement | null;
    buttonLoader: HTMLElement | null;
    isLoading: boolean = false;

    constructor(
        public capping: Capping,
        public utilizationObject: Utilization,
        public classSection: string = RwSelector.rwOwnerSelector
    ) {
        super(capping, utilizationObject, classSection);
    }

    init(): void {
        this.initialize();
        if (!this.section) {
            return;
        }

        this.initializePurchaseButton();
        this.initializeRwElement();
        this.initializeButtonLoader();

        this.bindSwimmerEvents();
        this.bindClickIDEvents();
        this.bindUtilization();
        this.showSwimmer();
    }

    initializePurchaseButton(): void {
        this.purchaseButton = DOMHelper.querySelector(this.purchaseSubscription) as HTMLElement;
    }

    initializeRwElement(): void {
        if (this.section) {
            this.rwElement = DOMHelper.querySelector(`[${UtilizationConstants.dataUtilizeRegistrationWall}]`, this.section) as HTMLElement;
        }
    }

    initializeButtonLoader(): void {
        if (this.rwElement) {
            this.buttonLoader = DOMHelper.querySelector(".button-loader", this.rwElement) as HTMLElement;
        }
    }

    bindClickIDEvents(): void {
        if (this.purchaseButton) {
            this.purchaseButton.addEventListener(EventType.CLICK, () => {
                this.utilize(BigDataClickID.purchaseSubscription, true);
            })
        }
    }

    bindUtilization(): void {
        if (this.rwElement) {
            this.rwElement.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();
                this.utilization();
            })
        }
    }

    utilization(): void {
        if (this.isLoading) return;

        this.isLoading = true;
        this.utilize(BigDataClickID.unlockAndRead);
        this.openArticleAndreloadLocation();
    }

    openArticleAndreloadLocation(): void {
        const article: string | null | undefined = DeviceInformationHelper.getXX();

        this.buttonLoader?.classList.add(UtilizationConstants.visible);

        if (article) {
            this.openArticle(article).then(
                () => {
                    this.reloadLocation();
                },
                (error: Error) => {
                    this.buttonLoader?.classList.remove(UtilizationConstants.visible);
                    this.isLoading = false;
                    console.error(error);
                }
            );
        }
    }

    reloadLocation(): void {
        setTimeout(() => {
            if (window.location) {
                window.location.reload();
            }
        }, 3000);
    }

    openArticle(article: string): Promise<any> {
        const url = "https://squid-api.wyborcza.pl/lead-catcher/leads/v2/article",
            headers: HttpHeaders = { "Content-Type": "application/json" };

        return httpInstance.put({
            url,
            headers,
            withCredentials: true,
            data: { article }
        });
    }
}
